import React from 'react'
import { ContextNotification } from '@pandiafi/components'
import { useTranslation } from 'react-i18next'

type TenantSelectionNotificationProps = {
  otherContractPartySelected: boolean
  genericError: string | undefined
}

export const TenantSelectionNotification: React.FC<
  TenantSelectionNotificationProps
> = ({ otherContractPartySelected, genericError }) => {
  const { t } = useTranslation(['contractModification'])

  if (otherContractPartySelected) {
    return (
      <ContextNotification type="info" textAlign="center" className="mb-6">
        {t('contractModification:texts.otherContractPartyTerminationInfo')}
      </ContextNotification>
    )
  }

  if (!genericError) {
    return null
  }

  return (
    <ContextNotification type="error" className="mb-6">
      {genericError}
    </ContextNotification>
  )
}
